<div *ngFor="let group of list; let indexGroup = index">
  <div class="row wrapper border-bottom page-heading px-0">
    <div class="col-lg-4">
      <h2>{{group?.tab_name}} \ {{group?.tab_group_name}}</h2>
    </div>

    <div class="col-lg-8 d-flex justify-content-end d-wrap px-3" *ngIf="permission?.can_save">
      <div class="btn-search" [ngClass]="{'question-btn': group?.active_ord}" *ngIf="group?.group?.length">
        <button class="btn btn-default" type="btn" *ngIf="!group?.active_ord" (click)="group.active_ord = true">Ordenar</button>
        <button class="btn btn-primary" type="btn" *ngIf="group?.active_ord" (click)="salvarOrdem(indexGroup)">Salvar Ordenação</button>
      </div>
      <div class="btn-search question-btn btn-new-question">
        <button class="btn btn-primary" type="btn" (click)="openModal(group?.id)">Vincular Questão</button>
      </div>
    </div>
  </div>

  <div class="system-table table-container">
    <div class="system-table-conteiner px-0">
      <table cdkDropList (cdkDropListDropped)="drop($event, indexGroup)" [cdkDropListDisabled]="!group?.active_ord" [ngClass]="{'ordenacao': group?.active_ord}">
        <thead>
          <tr>
            <th *ngIf="group?.active_ord" class="width5">Ordenação</th>
            <th class="width5">Código</th>
            <th>Questão</th>
            <th class="text-center width5">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of group.group; let i = index" cdkDrag>
            <td *ngIf="group?.active_ord" class="title">{{ i + 1 }}</td>
            <td class="title">{{ item?.id }}</td>
            <td><span class="title-span">{{ item?.title }}</span></td>
            <td>
              <div class="btn-icon" *ngIf="permission?.can_save">
                <span class="icon-table">
                  <img src="assets/images/svgs/trash.svg" alt="Excluir" tooltip="Desvincular" placement="bottom" (click)="confirmExcluir(item?.id)">
                </span>
              </div>
            </td>
          </tr>
          <tr *ngIf="!group.group?.length" class="border-b-radius">
            <td colspan="3" class="text-center">Nenhuma Questão Cadastrada.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
  
<div class="hr-line-dashed"></div>
<div class="form-group row d-flex justify-content-end">
  <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
    <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
  </div>
</div>

<ng-template #modal>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Vincular Questão</h4>
    <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body table-form">
    <div class="form-group row">
      <div class="col-sm-12 m-b">
        <label class="col-sm-12 pb-1">Questão<sup class="text-danger ms-2">*</sup></label>
        <ng-select class="ng-select-alternative" [items]="questionList" required bindLabel="label" bindValue="id" placeholder="Selecione a questão" [(ngModel)]="question.question_id" [clearable]="false">
        </ng-select>
      </div>
    </div>

    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end">
      <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-white m-r-xs" type="button" (click)="closeModal()">Fechar</button>
        <button class="btn btn-primary" type="button" [disabled]="!question.question_id" (click)="salvar()">Salvar</button>
      </div>
    </div>
  </div>
</ng-template>

<app-loading [loader]="isLoading"></app-loading>